module.exports = __webpack_public_path__ + "static_pc/img/9.d33875f9.jpg";